import {Box, Flex, P} from 'exsportia-components'
import React, {FC} from 'react'

import {useLocale} from '../../utils/i18n'

export type CreatedBookingItem = {
  bookingId?: string
  title?: string
  subtitle?: string
}

type Props = {
  bookings: CreatedBookingItem[]
  onSelect: (bookingId?: string) => void
}

// Lists the bookings created by a multi-session class booking, each linking to its own profile.
// Used both right after creation (in-app) and on the payment-success page after an external 3DS
// redirect, where the list is rebuilt from the server. Algolia indexing lags behind creation, so
// a redirect to the bookings list would render empty — hence this explicit list. WBA-4103.
export const CreatedBookingsModal: FC<Props> = ({bookings, onSelect}) => {
  const {l} = useLocale()
  return (
    <Box mb='12px'>
      <P
        fontSize='14px'
        color='#4a5568'
        mb='12px'
      >
        {l('bookings_created')}
      </P>
      {bookings.map(({bookingId, title, subtitle}, index) => (
        <Flex
          key={bookingId || index}
          justifyContent='space-between'
          alignItems='center'
          p='12px 16px'
          mb='8px'
          border='1px solid #e2e8f0'
          borderRadius='12px'
          cursor='pointer'
          onClick={() => onSelect(bookingId)}
        >
          <Box>
            {title && (
              <P
                fontSize='14px'
                fontWeight='600'
                color='#1a202c'
              >
                {title}
              </P>
            )}
            {subtitle && (
              <P
                fontSize='12px'
                color='#718096'
              >
                {subtitle}
              </P>
            )}
          </Box>
          <P
            fontSize='20px'
            color='#cbd5e0'
          >
            ›
          </P>
        </Flex>
      ))}
    </Box>
  )
}
